import React from 'react';
import CardMaterial from '../components/CardMaterial';
import useMediaQuery from '@mui/material/useMediaQuery';

const projects = [
  {heading:"Bonsai Clone",content:"A Time tracking app - bonsai for managing time spent on various tasks.",img:"./bonsai-clone.png",github:"https://github.com/deepumandal/petite-swing-7786",deploy:"https://petite-swing-7786.vercel.app/", techStacks:["React","JavaScript","CSS","HTML"]},
  {heading:"Sugar Cosmetics Clone",content:"Team of 5 members made a clone of Sugar Cosmetics in 6 days. It is made with NextJS. I have worked on the wishlist and payments part. You have to login first, then wishlist becomes visible",img:"sugar-cosmetics.png",github:"https://github.com/sharangahirekar1/sugar-cosmetics-clone",deploy:"https://sugar-cosmetics-clone-mu.vercel.app/",techStacks:["NextJS","MongoDB","MaterialUI","Firebase"]},
  {heading:"SSense Clone",content:"A Team project, cloning Ssense - ecommerce site with Javascript in 6 days. I have worked on wishlist, checkout page and learned about CSS Positioning in Product view page.",img:"./ssense-clone.png",github:"https://github.com/sharangahirekar1/Ssense-clone",deploy:"https://ssense-clone-ruddy.vercel.app/",techStacks:["HTML","CSS","Javascript"]},
  {heading:"Todo Full Stack",content:"A Full stack todo application, which can add, delete, update todos. A user can login into his account, and manage his personalized todos. It also features Gemini AI so that user can be more productive",img:"./todo-full-stack.png",github:"https://github.com/sharangahirekar1/todo-full-stack",deploy:"https://todo-front-topaz.vercel.app/",techStacks:["React","MongoDB","Express","MaterialUI","Render"]},
  ]
const Projects = () => {
  const mediaMatch = useMediaQuery('(min-width:600px)');
  return (
    <div>
      <div style={{fontSize:'24px',textAlign:'center',marginBottom:3,paddingTop:10}}>PROJECTS</div>
      <div style={{
        display:'grid',
        gridTemplateColumns:mediaMatch?'repeat(2,1fr)':'repeat(1,1fr)',
        gap:'40px',
        padding:'15px'
      }}>

          {projects.map((p,i)=>{
            return  <div key={i}>
              <CardMaterial {...p} k={i} />
            </div>
          })}
      </div>
    </div>
  )
}

export default Projects